import AXIOS from '@/API/ApiConfig';

import type { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosError, AxiosRequestConfig } from 'axios';

export type AxiosBaseQueryArgs = {
	url: string;
	method?: AxiosRequestConfig['method'];
	data?: AxiosRequestConfig['data'];
	params?: AxiosRequestConfig['params'];
	headers?: AxiosRequestConfig['headers'];
	signal?: AbortSignal;
};

export const axiosBaseQuery =
	(): BaseQueryFn<AxiosBaseQueryArgs, unknown, unknown> =>
	async ({ url, method = 'GET', data, params, headers, signal }) => {
		try {
			const result = await AXIOS({
				url,
				method,
				data,
				params,
				headers,
				signal,
			});
			return { data: result.data };
		} catch (axiosError) {
			const err = axiosError as AxiosError;
			return {
				error: {
					status: err.response?.status,
					data: err.response?.data || err.message,
				},
			};
		}
	};
